import React from "react";
import {Route} from "react-router-dom";
import {
  BredDogs,
  DogPaymentSuccess,
  DogRegistrationContainer,
  LitterPaymentSuccess,
  LitterRegistrationContainer,
  MyDogs,
  PedigreeTool,
  Registrations,
  UserProfile,
} from "./lazyPages";

export const privateRoutes = (
  <>
    <Route path="user" element={<UserProfile />} />
    <Route path="login" element={<UserProfile />} />
    <Route path="mydogs" element={<MyDogs />} />
    <Route path="mylitters" element={<BredDogs />} />
    <Route path=":organizationPrefix/litter-registration" element={<LitterRegistrationContainer />} />
    <Route path=":organizationPrefix/litter-registration/:id/success" element={<LitterPaymentSuccess />} />
    <Route path=":organizationPrefix/dog-registration" element={<DogRegistrationContainer />} />
    <Route path=":organizationPrefix/dog-registration/:id/success" element={<DogPaymentSuccess />} />
    <Route path="registrations" element={<Registrations />} />
    <Route path=":organizationPrefix/pedigreetool/:id?" element={<PedigreeTool />} />
  </>
);
